import {
    BannerAndModalMessage,
    isBannerAndModalMessage,
} from '@treasury/domain/dashboard/banner-modal-message.entity';
import { InformationCenterMessage } from '@treasury/domain/dashboard/information-center-message.entity';
import { InformationCenterMessageType } from '@treasury/domain/dashboard/types';
import {
    circleWarningIcon,
    informationIcon,
    notificationsIcon,
} from '@treasury/presentation/assets/icons';
import { html } from 'lit';

/**
 * transform information center message entity to API needed
 * for tm-accordion
 * summary
 * disabled
 * theme
 * detail
 */

export class InformationCenterItemVm {
    constructor(public message: InformationCenterMessage | BannerAndModalMessage) {}

    public get summary() {
        return html`<div class="flex items-center">
            <div class="flex mr-2">${this.icon}</div>
            <div class="pr-3 text-header font-medium">${this.message.title}</div>
        </div>`;
    }

    public get detail() {
        return html`<div
            class="text-sm ${this.message.type !== 'Modal' ? 'pr-6 pb-4 pl-8' : undefined}"
        >
            ${this.message.description}
        </div>`;
    }

    public get disabled() {
        return false;
    }

    public get theme() {
        return 'reverse';
    }

    public get sequence() {
        if (isBannerAndModalMessage(this.message)) {
            return undefined;
        }
        return (this.message as InformationCenterMessage).sequence;
    }

    public get type() {
        return this.message.type;
    }

    public get icon() {
        switch (this.message.type) {
            case InformationCenterMessageType.Info:
                return html`<tm-icon
                    color="var(--content-brand)"
                    .icon=${informationIcon}
                ></tm-icon>`;
            case InformationCenterMessageType.Warning:
                return html`<tm-icon
                    color="var(--content-attention)"
                    .icon=${circleWarningIcon}
                ></tm-icon>`;
            case InformationCenterMessageType.Alert:
                return html`<tm-icon
                    color="var(--content-negative)"
                    .icon=${notificationsIcon}
                ></tm-icon>`;
            default:
                return html`<tm-icon
                    color="var(--content-brand)"
                    .icon=${informationIcon}
                ></tm-icon>`;
        }
    }
}
